<template>
  <div class="sale-form-page">
    <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
    <app-page-header :title="`Venda`">
      <button
        v-app-button.icon-left.clear
        v-app-back-button="{ name: 'sales.index' }"
      >
        <b-icon size="is-small" icon="arrow-left" />Voltar
      </button>
    </app-page-header>
    <app-card>
      <div class="container">
        <div v-if="!isLoading" class="row">
          <div class="col-3 field">
            <div class="row">
              <strong>Data</strong>
            </div>
            <div class="row">
              <span>{{ sale.datetime }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>Rede</strong>
            </div>
            <div class="row">
              <span>{{ sale.network.name }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>CNPJ Emissão</strong>
            </div>
            <div class="row">
              <span>{{
                sale.emission_cnpj | VMask('##.###.###/####-##')
              }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>CNPJ Unidade</strong>
            </div>
            <div class="row">
              <span>{{ sale.unit_cnpj | VMask('##.###.###/####-##') }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>Código</strong>
            </div>
            <div class="row">
              <span>{{ sale.product_code }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>Código Philco</strong>
            </div>
            <div class="row">
              <span>{{ sale.philco_product_code }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>Código EAN</strong>
            </div>
            <div class="row">
              <span>{{ sale.ean_code }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>Descrição produto</strong>
            </div>
            <div class="row">
              <span>{{ sale.product_description }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>Familia Produto</strong>
            </div>
            <div class="row">
              <span>{{ sale.product_family }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>Quantidade</strong>
            </div>
            <div class="row">
              <span>{{ sale.quantity }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>Valor Unitário</strong>
            </div>
            <div class="row">
              <span>{{ sale.unit_value }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>Data venda</strong>
            </div>
            <div class="row">
              <span>{{ sale.sale_date }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>Número cupom nota</strong>
            </div>
            <div class="row">
              <span>{{ sale.invoice_coupon_number }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>CPF Vendedor</strong>
            </div>
            <div class="row">
              <span>{{ sale.seller_cpf | VMask('###.###.###-##') }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>Nome Vendedor</strong>
            </div>
            <div class="row">
              <span>{{ sale.seller_name }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>CPF Subgerente</strong>
            </div>
            <div class="row">
              <span>{{ sale.submanager_cpf | VMask('###.###.###-##') }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>Nome Subgerente</strong>
            </div>
            <div class="row">
              <span>{{ sale.submanager_name }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>CPF Gerente</strong>
            </div>
            <div class="row">
              <span>{{ sale.manager_cpf | VMask('###.###.###-##') }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>Nome Gerente</strong>
            </div>
            <div class="row">
              <span>{{ sale.manager_name }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>CPF Supervisor Regional</strong>
            </div>
            <div class="row">
              <span>{{
                sale.regional_supervisor_cpf | VMask('###.###.###-##')
              }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>Nome Supervisor Regional</strong>
            </div>
            <div class="row">
              <span>{{ sale.regional_supervisor_name }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>CPF Gerente Regional</strong>
            </div>
            <div class="row">
              <span>{{
                sale.regional_manager_cpf | VMask('###.###.###-##')
              }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>Nome Gerente Regional</strong>
            </div>
            <div class="row">
              <span>{{ sale.regional_manager_name }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>Pontos acumulados</strong>
            </div>
            <div class="row">
              <span>{{ sale.points }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>Pontos gerente</strong>
            </div>
            <div class="row">
              <span>{{ sale.manager_points }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>Pontos subgerente</strong>
            </div>
            <div class="row">
              <span>{{ sale.submanager_points }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>Pontos supervisor regional</strong>
            </div>
            <div class="row">
              <span>{{ sale.regional_supervisor_points }}</span>
            </div>
          </div>

          <div class="col-3 field">
            <div class="row">
              <strong>Pontos gerente</strong>
            </div>
            <div class="row">
              <span>{{ sale.regional_manager_points }}</span>
            </div>
          </div>
        </div>
      </div>
    </app-card>
  </div>
</template>

<script>
import SaleService from '@/services/sale.service';
import ToastMixin from '@/mixins/ToastifyMixin';

import moment from 'moment';

export default {
  name: 'sale-form-page',
  mixins: [ToastMixin],
  data: () => {
    return {
      isLoading: true,
      sale: {},
    };
  },
  methods: {
    loadSale() {
      this.isLoading = true;
      SaleService.getId(this.$route.params.id)
        .then((response) => {
          this.sale = response.data;
          this.sale.datetime = moment(this.sale.datetime).format('LL');
          this.sale.sale_date = moment(this.sale.sale_date).format('LL');
        })
        .catch(() => this.toastify('Erro ao carregar Venda.', 'error'))
        .finally(() => (this.isLoading = false));
    },
  },
  beforeMount() {
    this.loadSale();
  },
};
</script>

<style lang="scss" scoped>
.field {
  margin-bottom: 1em;
}
</style>
